import { Box } from '@mui/material';
import { LoadingSpinner } from '../LoadingSpinner';
import { useTranslation } from 'react-i18next';
import { usePolling } from '../redirection/usePolling';

export const ProcessingStep = () => {
	const { t } = useTranslation(undefined, { keyPrefix: 'processing-step' });
	usePolling();

	const message = t('processing-message');
	return (
		<Box id="processing-step">
			<LoadingSpinner title={message}>
				<></>
			</LoadingSpinner>
		</Box>
	);
};
